import { ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import React from 'react';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkLineSkeleton } from 'uitk-react-skeleton';

const LoadingSkeleton = () => {
  return (
    <div className="loading-skeleton">
      <Viewport>
        <ViewSmall>
          <UitkLayoutFlex space="six" direction="column">
            <UitkLineSkeleton animation type="primary" />
            <UitkLineSkeleton animation type="primary" />
            <UitkLineSkeleton animation type="primary" />
            <UitkLineSkeleton animation type="primary" />
            <UitkLineSkeleton animation type="secondary" />
            <UitkLineSkeleton animation type="secondary" />
            <UitkLineSkeleton animation type="secondary" />
            <UitkLineSkeleton animation type="secondary" />
          </UitkLayoutFlex>
        </ViewSmall>
        <ViewMedium>
          <UitkLayoutFlex space="six" direction="column">
            <div>
              <UitkLayoutFlex space="three">
                <UitkLineSkeleton animation type="primary" />
                <UitkLineSkeleton animation type="primary" />
                <UitkLineSkeleton animation type="primary" />
              </UitkLayoutFlex>
            </div>
            <div>
              <UitkLayoutFlex space="three">
                <UitkLineSkeleton animation type="primary" />
                <UitkLineSkeleton animation type="primary" />
              </UitkLayoutFlex>
            </div>
            <div>
              <UitkLayoutFlex space="three">
                <UitkLineSkeleton animation type="primary" />
                <UitkLineSkeleton animation type="primary" />
              </UitkLayoutFlex>
            </div>
          </UitkLayoutFlex>
        </ViewMedium>
      </Viewport>
    </div>
  );
};

export default LoadingSkeleton;
